
  import {
      linkTypeMap,
      createClient as createClientOriginal,
      generateGraphqlOperation,
      assertSameVersion,
  } from '@gqlts/runtime'
  import types from './types.esm'
  var typeMap = linkTypeMap(types)
  export * from './guards.esm'

  export var version = "3.4.2"
  assertSameVersion(version)

  export var createClient = 
function(options) {
    options = options || {}
    var optionsCopy = {
      url: "https://hasura.cloud.shaggaga.ly/v1/graphql",
      queryRoot: typeMap.Query,
      mutationRoot: typeMap.Mutation,
      subscriptionRoot: typeMap.Subscription,
    }
    for (var name in options) {
      optionsCopy[name] = options[name];
    }
    return createClientOriginal(optionsCopy)
}

  export const enumaddressesSelectColumn = {
  buyer_id: 'buyer_id',
  city: 'city',
  description: 'description',
  id: 'id',
  location: 'location',
  name: 'name',
  seller_id: 'seller_id',
  undefined_buyer_id: 'undefined_buyer_id',
  verification_status: 'verification_status'
}

export const enumbuyersSelectColumn = {
  has_whatsapp: 'has_whatsapp',
  id: 'id',
  image_id: 'image_id',
  name: 'name',
  phone_number: 'phone_number'
}

export const enumcursorOrdering = {
  ASC: 'ASC',
  DESC: 'DESC'
}

export const enumdriversCollectionInvoicesInSelectColumn = {
  date_created: 'date_created',
  date_updated: 'date_updated',
  driver_id: 'driver_id',
  id: 'id',
  invoice_amount: 'invoice_amount',
  invoice_number: 'invoice_number',
  issued_by: 'issued_by',
  payment_timestamp: 'payment_timestamp',
  received_by: 'received_by',
  route_id: 'route_id'
}

export const enumdriversLocationsConstraint = {
  driver_locations_pkey: 'driver_locations_pkey'
}

export const enumdriversLocationsSelectColumn = {
  altitude: 'altitude',
  altitude_accuracy: 'altitude_accuracy',
  bearing_string: 'bearing_string',
  driver_id: 'driver_id',
  id: 'id',
  latitude: 'latitude',
  location: 'location',
  location_accuracy_radius: 'location_accuracy_radius',
  location_recorded_time_unix: 'location_recorded_time_unix',
  longitude: 'longitude',
  simulated: 'simulated',
  speed: 'speed'
}

export const enumdriversLocationsUpdateColumn = {
  _PLACEHOLDER: '_PLACEHOLDER'
}

export const enumdriversPayoutsReceiptsOutSelectColumn = {
  date_created: 'date_created',
  date_updated: 'date_updated',
  driver_id: 'driver_id',
  id: 'id',
  invoice_number: 'invoice_number',
  issued_by: 'issued_by',
  paid_by: 'paid_by',
  payment_timestamp: 'payment_timestamp',
  payout_amount: 'payout_amount'
}

export const enumdriversSelectColumn = {
  date_created: 'date_created',
  date_updated: 'date_updated',
  duty_time_windows_utc: 'duty_time_windows_utc',
  end_location: 'end_location',
  force_sync: 'force_sync',
  has_whatsapp: 'has_whatsapp',
  id: 'id',
  image_id: 'image_id',
  is_active: 'is_active',
  mobile_device_token: 'mobile_device_token',
  name: 'name',
  phone_number: 'phone_number',
  start_location: 'start_location',
  web_device_token: 'web_device_token'
}

export const enumdriversSkillsSelectColumn = {
  driver_id: 'driver_id',
  id: 'id',
  skill_id: 'skill_id'
}

export const enumenvVariablesSelectColumn = {
  id: 'id',
  key: 'key',
  value: 'value',
  value_type: 'value_type'
}

export const enumfoodCategoriesProductsSelectColumn = {
  food_categories_id: 'food_categories_id',
  id: 'id',
  products_id: 'products_id'
}

export const enumfoodCategoriesSelectColumn = {
  id: 'id',
  name: 'name'
}

export const enummessagesConstraint = {
  messages_pkey: 'messages_pkey'
}

export const enummessagesFromConstraint = {
  messages_from_message_id_key: 'messages_from_message_id_key',
  messages_from_pkey: 'messages_from_pkey'
}

export const enummessagesFromSelectColumn = {
  buyer_id: 'buyer_id',
  date_created: 'date_created',
  date_updated: 'date_updated',
  driver_id: 'driver_id',
  id: 'id',
  message_id: 'message_id',
  operator_id: 'operator_id',
  seller_id: 'seller_id',
  undefined_buyer_id: 'undefined_buyer_id'
}

export const enummessagesFromUpdateColumn = {
  _PLACEHOLDER: '_PLACEHOLDER'
}

export const enummessagesSelectColumn = {
  attachment: 'attachment',
  date_created: 'date_created',
  date_updated: 'date_updated',
  id: 'id',
  location_stamp: 'location_stamp',
  read_timestamp: 'read_timestamp',
  shipment_id: 'shipment_id',
  text: 'text'
}

export const enummessagesToConstraint = {
  messages_to_message_id_key: 'messages_to_message_id_key',
  messages_to_pkey: 'messages_to_pkey'
}

export const enummessagesToSelectColumn = {
  buyer_id: 'buyer_id',
  date_created: 'date_created',
  date_updated: 'date_updated',
  driver_id: 'driver_id',
  id: 'id',
  message_id: 'message_id',
  operator_id: 'operator_id',
  seller_id: 'seller_id',
  undefined_buyer_id: 'undefined_buyer_id'
}

export const enummessagesToUpdateColumn = {
  _PLACEHOLDER: '_PLACEHOLDER'
}

export const enummessagesUpdateColumn = {
  read_timestamp: 'read_timestamp'
}

export const enumoperatorsSelectColumn = {
  id: 'id',
  image_id: 'image_id',
  name: 'name'
}

export const enumorderBy = {
  asc: 'asc',
  asc_nulls_first: 'asc_nulls_first',
  asc_nulls_last: 'asc_nulls_last',
  desc: 'desc',
  desc_nulls_first: 'desc_nulls_first',
  desc_nulls_last: 'desc_nulls_last'
}

export const enumproductsExtrasSelectColumn = {
  description: 'description',
  id: 'id',
  is_available: 'is_available',
  name: 'name',
  price: 'price',
  product_id: 'product_id'
}

export const enumproductsSelectColumn = {
  description: 'description',
  dimensions_cm: 'dimensions_cm',
  extra_images_ids: 'extra_images_ids',
  id: 'id',
  image_id: 'image_id',
  is_available: 'is_available',
  is_deleted: 'is_deleted',
  is_retail: 'is_retail',
  min_quantity: 'min_quantity',
  name: 'name',
  price: 'price',
  retail_price: 'retail_price',
  seller_id: 'seller_id',
  standard_size_id: 'standard_size_id',
  volume_cm3: 'volume_cm3'
}

export const enumsalesChannelsSelectColumn = {
  id: 'id',
  name: 'name',
  platform_type: 'platform_type'
}

export const enumsellerProductsStandardSizesSelectColumn = {
  date_created: 'date_created',
  date_updated: 'date_updated',
  height: 'height',
  id: 'id',
  length: 'length',
  name: 'name',
  seller_id: 'seller_id',
  volume_cm3: 'volume_cm3',
  width: 'width'
}

export const enumsellersSelectColumn = {
  description: 'description',
  extra_images_ids: 'extra_images_ids',
  id: 'id',
  image_id: 'image_id',
  is_available: 'is_available',
  name: 'name',
  ops_has_whatsapp: 'ops_has_whatsapp',
  ops_phone_number: 'ops_phone_number',
  pickup_time_windows_utc: 'pickup_time_windows_utc',
  public_has_whatsapp: 'public_has_whatsapp',
  public_phone_number: 'public_phone_number',
  seller_number: 'seller_number',
  shipping_geofence: 'shipping_geofence'
}

export const enumshipmentProductItemExtrasSelectColumn = {
  calculated_price: 'calculated_price',
  id: 'id',
  product_extra_id: 'product_extra_id',
  quantity: 'quantity',
  shipment_product_item_id: 'shipment_product_item_id'
}

export const enumshipmentProductsItemsSelectColumn = {
  calculated_price: 'calculated_price',
  calculated_seller_price: 'calculated_seller_price',
  date_created: 'date_created',
  date_updated: 'date_updated',
  id: 'id',
  product_id: 'product_id',
  quantity: 'quantity',
  shipment_id: 'shipment_id'
}

export const enumshipmentsBoxesSelectColumn = {
  date_created: 'date_created',
  date_updated: 'date_updated',
  description: 'description',
  dimensions_cm: 'dimensions_cm',
  id: 'id',
  is_deleted: 'is_deleted',
  name: 'name',
  price: 'price',
  quantity: 'quantity',
  retail_price: 'retail_price',
  shipment_id: 'shipment_id',
  standard_size_id: 'standard_size_id',
  volume_cm3: 'volume_cm3'
}

export const enumshipmentsNotesSelectColumn = {
  created_at: 'created_at',
  id: 'id',
  note: 'note',
  role: 'role',
  shipment_id: 'shipment_id',
  type: 'type',
  user_id: 'user_id'
}

export const enumshipmentsPaymentsSelectColumn = {
  amount: 'amount',
  date_created: 'date_created',
  id: 'id',
  method: 'method',
  notes: 'notes',
  payment_gateway: 'payment_gateway',
  payment_reference: 'payment_reference',
  shipment_id: 'shipment_id',
  status: 'status',
  transaction_type: 'transaction_type'
}

export const enumshipmentsRoutesSelectColumn = {
  assigned_driver_id: 'assigned_driver_id',
  date_created: 'date_created',
  date_updated: 'date_updated',
  id: 'id',
  is_active: 'is_active',
  route_number: 'route_number',
  route_shape_string: 'route_shape_string'
}

export const enumshipmentsRoutesStepsSelectColumn = {
  address_id: 'address_id',
  date_created: 'date_created',
  date_updated: 'date_updated',
  distance_m: 'distance_m',
  driver_cost: 'driver_cost',
  duration_s: 'duration_s',
  eta: 'eta',
  id: 'id',
  service: 'service',
  shipments_route_id: 'shipments_route_id',
  status: 'status',
  step_order: 'step_order',
  type: 'type'
}

export const enumshipmentsRoutesStepsShipmentsSelectColumn = {
  collected_amount: 'collected_amount',
  completion_timestamp: 'completion_timestamp',
  date_created: 'date_created',
  date_updated: 'date_updated',
  eta: 'eta',
  eta_updated: 'eta_updated',
  id: 'id',
  is_completed: 'is_completed',
  is_noshow: 'is_noshow',
  shipment_id: 'shipment_id',
  shipments_routes_step_id: 'shipments_routes_step_id',
  type: 'type'
}

export const enumshipmentsSelectColumn = {
  allowed_payment_methods: 'allowed_payment_methods',
  amount_paid: 'amount_paid',
  assigned_driver_id: 'assigned_driver_id',
  base_shipping_cost: 'base_shipping_cost',
  buyer_id: 'buyer_id',
  cancellation_object: 'cancellation_object',
  company_discount: 'company_discount',
  date_created: 'date_created',
  date_updated: 'date_updated',
  delivered_timestamp: 'delivered_timestamp',
  destination_address_id: 'destination_address_id',
  driver_payout_receipt_out_id: 'driver_payout_receipt_out_id',
  driver_route_invoice_in_id: 'driver_route_invoice_in_id',
  dynamic_shipping_cost: 'dynamic_shipping_cost',
  eta: 'eta',
  eta_updated: 'eta_updated',
  external_reference_id: 'external_reference_id',
  id: 'id',
  is_active: 'is_active',
  is_company_free_shipping: 'is_company_free_shipping',
  is_seller_free_shipping: 'is_seller_free_shipping',
  payment_status: 'payment_status',
  preferred_delivery_time_windows_utc: 'preferred_delivery_time_windows_utc',
  products_cost: 'products_cost',
  products_cost_seller: 'products_cost_seller',
  products_paid_in_advance: 'products_paid_in_advance',
  ready_time: 'ready_time',
  required_amount: 'required_amount',
  route_id: 'route_id',
  sales_channel_id: 'sales_channel_id',
  seller_discount: 'seller_discount',
  seller_id: 'seller_id',
  shipment_number: 'shipment_number',
  shipping_cost: 'shipping_cost',
  status: 'status',
  undefined_buyer_id: 'undefined_buyer_id'
}

export const enumshipmentsSelectColumnShipmentsAggregateBoolExpBoolAndArgumentsColumns = {
  is_active: 'is_active',
  is_company_free_shipping: 'is_company_free_shipping',
  is_seller_free_shipping: 'is_seller_free_shipping',
  products_paid_in_advance: 'products_paid_in_advance'
}

export const enumshipmentsSelectColumnShipmentsAggregateBoolExpBoolOrArgumentsColumns = {
  is_active: 'is_active',
  is_company_free_shipping: 'is_company_free_shipping',
  is_seller_free_shipping: 'is_seller_free_shipping',
  products_paid_in_advance: 'products_paid_in_advance'
}

export const enumshippingCostPerCitySelectColumn = {
  base_cost: 'base_cost',
  city: 'city',
  cm3_multiplier: 'cm3_multiplier',
  date_created: 'date_created',
  date_updated: 'date_updated',
  geo_fence: 'geo_fence',
  id: 'id',
  minimum_cost: 'minimum_cost'
}

export const enumskillsSelectColumn = {
  id: 'id',
  name: 'name'
}

export const enumundefinedBuyersSelectColumn = {
  has_whatsapp: 'has_whatsapp',
  id: 'id',
  name: 'name',
  phone_number: 'phone_number'
}


  export var generateQueryOp = function(fields) {
    return generateGraphqlOperation('query', typeMap.Query, fields)
  }
  export var generateMutationOp = function(fields) {
    return generateGraphqlOperation('mutation', typeMap.Mutation, fields)
  }
  export var generateSubscriptionOp = function(fields) {
    return generateGraphqlOperation('subscription', typeMap.Subscription, fields)
  }
  export var everything = {
    __scalar: true
  }
  